import type { PlayerBackendComponent, PlayerBackendKind } from '../types'
import { HtmlVideoPlayer } from './html-video-player'
import { LibmpvPlayer } from './libmpv-player'
import { ShakaPlayer } from './shaka-player'

const backends: Record<PlayerBackendKind, PlayerBackendComponent> = {
  'html-video': HtmlVideoPlayer,
  libmpv: LibmpvPlayer,
  shaka: ShakaPlayer,
}

export { backends }
